import readings from "#traditional-word-readings" with { type: "json" };

/** The named accessor lets native Metro defer the other script's JSON initialization. */
export function getTraditionalWordReadings() {
  return readings;
}
